module.exports = __webpack_public_path__ + "img/nav-menu-message.a3f80802.svg";